var Handlebars = require("/home/travis/build/thelounge/lounge/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "Topic set by\n"
    + ((stack1 = container.invokePartial(require("/home/travis/build/thelounge/lounge/client/views/user_name.tpl"),depth0,{"name":"../user_name","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "on "
    + container.escapeExpression(__default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/localetime.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.when : depth0),{"name":"localetime","hash":{},"data":data}))
    + "\n";
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./client/views/actions/topic_set_by.tpl
// module id = 228
// module chunks = 0